/**
 * @generated SignedSource<<a89f9ab76713e100c43a5ef440eb0bbb>>
 * @relayHash 95226f555e4cd9efaf3e2ef17f32be57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f09b7daae44197c6ccb5b6c0f121cea2ab89565a6fb603321045725549e0fe99

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type editCustomPageQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
  helpCenterPageAri: string;
};
export type editCustomPageQuery$data = {
  readonly helpCenter: {
    readonly helpCenterPageById: {
      readonly __typename: "QueryError";
      readonly id?: string;
      readonly " $fragmentSpreads": FragmentRefs<"handleQueryErrorFragment">;
    } | null | undefined;
    readonly mediaConfig: {
      readonly " $fragmentSpreads": FragmentRefs<"globalBrandingSettingsPanelMediaConfigFragment">;
    };
  } | null | undefined;
  readonly helpLayout: {
    readonly elementTypes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"elementsCatalogueFragment">;
    }> | null | undefined;
    readonly layoutByParentId: {
      readonly __typename: "QueryError";
      readonly id?: string;
      readonly " $fragmentSpreads": FragmentRefs<"handleQueryErrorFragment" | "pageBuilderFragment">;
    };
    readonly mediaConfig: {
      readonly " $fragmentSpreads": FragmentRefs<"pageBuilderMediaConfigFragment">;
    };
  };
};
export type editCustomPageQuery = {
  response: editCustomPageQuery$data;
  variables: editCustomPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterPageAri"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "helpCenterPageAri",
    "variableName": "helpCenterPageAri"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "HelpCenterPage"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    {
      "kind": "FragmentSpread",
      "name": "handleQueryErrorFragment"
    }
  ],
  "type": "QueryError"
},
v10 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "helpCenterAri"
},
v11 = [
  (v10/*: any*/)
],
v12 = [
  (v10/*: any*/),
  {
    "kind": "Variable",
    "name": "parentAri",
    "variableName": "helpCenterPageAri"
  }
],
v13 = [
  {
    "kind": "Variable",
    "name": "parentAri",
    "variableName": "helpCenterAri"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "message"
},
v15 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ]
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/)
  ],
  "type": "QueryError"
},
v17 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v18 = {
  "kind": "ScalarField",
  "name": "mediaUrl"
},
v19 = {
  "kind": "ScalarField",
  "name": "mediaToken"
},
v20 = {
  "kind": "ScalarField",
  "name": "mediaCollectionName"
},
v21 = {
  "kind": "ScalarField",
  "name": "asapIssuer"
},
v22 = [
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v24 = {
  "kind": "ScalarField",
  "name": "key"
},
v25 = {
  "kind": "ScalarField",
  "name": "horizontalAlignment"
},
v26 = {
  "kind": "ScalarField",
  "name": "verticalAlignment"
},
v27 = {
  "kind": "ScalarField",
  "name": "__id"
},
v28 = {
  "kind": "ClientExtension",
  "selections": [
    (v27/*: any*/)
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "fileId"
},
v30 = {
  "kind": "ScalarField",
  "name": "url"
},
v31 = {
  "concreteType": "HelpLayoutBackgroundImage",
  "kind": "LinkedField",
  "name": "backgroundImage",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v30/*: any*/)
  ]
},
v32 = {
  "kind": "ScalarField",
  "name": "backgroundType"
},
v33 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v34 = {
  "kind": "ScalarField",
  "name": "foregroundColor"
},
v35 = {
  "kind": "ScalarField",
  "name": "hidden"
},
v36 = {
  "kind": "ScalarField",
  "name": "titleColor"
},
v37 = {
  "kind": "ScalarField",
  "name": "name"
},
v38 = {
  "kind": "ScalarField",
  "name": "logo"
},
v39 = {
  "kind": "ScalarField",
  "name": "portalId"
},
v40 = {
  "concreteType": "HelpLayoutAlignmentSettings",
  "kind": "LinkedField",
  "name": "alignment",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v26/*: any*/)
  ]
},
v41 = {
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v40/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/)
  ]
},
v42 = {
  "concreteType": "HelpLayoutAtomicElementType",
  "kind": "LinkedField",
  "name": "elementType",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v24/*: any*/)
  ]
},
v43 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isHelpLayoutVisualEntity"
},
v44 = {
  "concreteType": "HelpLayoutBackgroundImage",
  "kind": "LinkedField",
  "name": "backgroundImage",
  "plural": false,
  "selections": [
    (v30/*: any*/),
    (v29/*: any*/)
  ]
},
v45 = {
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/)
  ]
},
v46 = {
  "kind": "ScalarField",
  "name": "isInstalled"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editCustomPageQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterPageById",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v9/*: any*/)
            ]
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": (v11/*: any*/),
              "concreteType": "HelpCenterMediaConfig",
              "kind": "LinkedField",
              "name": "mediaConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "globalBrandingSettingsPanelMediaConfigFragment"
                }
              ]
            },
            "action": "THROW",
            "path": "helpCenter.mediaConfig"
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v3/*: any*/),
          "concreteType": "HelpLayoutQueryApi",
          "kind": "LinkedField",
          "name": "helpLayout",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v12/*: any*/),
                "kind": "LinkedField",
                "name": "layoutByParentId",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "pageBuilderFragment"
                      }
                    ],
                    "type": "HelpLayout"
                  },
                  (v9/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "helpLayout.layoutByParentId"
            },
            {
              "kind": "RequiredField",
              "field": {
                "args": (v13/*: any*/),
                "concreteType": "HelpLayoutMediaConfig",
                "kind": "LinkedField",
                "name": "mediaConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "pageBuilderMediaConfigFragment"
                  }
                ]
              },
              "action": "THROW",
              "path": "helpLayout.mediaConfig"
            },
            {
              "kind": "LinkedField",
              "name": "elementTypes",
              "plural": true,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "elementsCatalogueFragment"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "helpLayout"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "editCustomPageQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterPageById",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v7/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          },
          {
            "args": (v11/*: any*/),
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "mediaConfig",
            "plural": false,
            "selections": (v22/*: any*/)
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "args": (v12/*: any*/),
            "kind": "LinkedField",
            "name": "layoutByParentId",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/),
                  {
                    "concreteType": "HelpLayoutSectionConnection",
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpLayoutSectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "HelpLayoutSection",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpLayoutSubsection",
                                "kind": "LinkedField",
                                "name": "subsections",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "HelpLayoutSubsectionConfig",
                                    "kind": "LinkedField",
                                    "name": "config",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "span"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "elements",
                                    "plural": true,
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isHelpLayoutElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "adf"
                                          },
                                          {
                                            "concreteType": "HelpLayoutAtomicElementType",
                                            "kind": "LinkedField",
                                            "name": "elementType",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "args": (v13/*: any*/),
                                                "concreteType": "HelpLayoutMediaConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaConfig",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v19/*: any*/),
                                                  (v18/*: any*/),
                                                  (v21/*: any*/)
                                                ]
                                              },
                                              (v23/*: any*/),
                                              (v24/*: any*/)
                                            ]
                                          },
                                          (v5/*: any*/),
                                          {
                                            "concreteType": "HelpLayoutVisualConfig",
                                            "kind": "LinkedField",
                                            "name": "visualConfig",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "HelpLayoutAlignmentSettings",
                                                "kind": "LinkedField",
                                                "name": "alignment",
                                                "plural": false,
                                                "selections": [
                                                  (v25/*: any*/),
                                                  (v26/*: any*/),
                                                  (v28/*: any*/)
                                                ]
                                              },
                                              (v31/*: any*/),
                                              (v32/*: any*/),
                                              (v33/*: any*/),
                                              (v34/*: any*/),
                                              (v35/*: any*/),
                                              (v36/*: any*/)
                                            ]
                                          },
                                          (v28/*: any*/)
                                        ],
                                        "type": "HelpLayoutEditorElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutPortalCard",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": true,
                                            "selections": [
                                              (v37/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "description"
                                              },
                                              (v38/*: any*/),
                                              (v39/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "isFeatured"
                                              },
                                              (v8/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "expandButtonTextColor"
                                          },
                                          (v41/*: any*/),
                                          (v5/*: any*/),
                                          (v42/*: any*/),
                                          (v43/*: any*/)
                                        ],
                                        "type": "HelpLayoutPortalsListElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutRequestForm",
                                            "kind": "LinkedField",
                                            "name": "suggestedRequestTypes",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "descriptionHtml"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "portalName"
                                              },
                                              (v5/*: any*/),
                                              (v39/*: any*/),
                                              (v37/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                              },
                                              (v8/*: any*/)
                                            ]
                                          },
                                          (v41/*: any*/),
                                          (v5/*: any*/),
                                          (v42/*: any*/),
                                          (v43/*: any*/)
                                        ],
                                        "type": "HelpLayoutSuggestedRequestFormsListElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "header"
                                          },
                                          (v14/*: any*/),
                                          (v42/*: any*/)
                                        ],
                                        "type": "HelpLayoutAnnouncementElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "topicId"
                                              },
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "HelpLayoutTopicItem",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": true,
                                                "selections": [
                                                  (v8/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                  },
                                                  (v38/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "displayLink"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "entityKey"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "helpObjectType"
                                                  },
                                                  (v28/*: any*/)
                                                ]
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "topicName"
                                              }
                                            ]
                                          },
                                          (v41/*: any*/),
                                          (v5/*: any*/),
                                          (v42/*: any*/),
                                          (v43/*: any*/)
                                        ],
                                        "type": "HelpLayoutTopicsListElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "useGlobalSettings"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "homePageTitle"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "userLanguageTag"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "showCSMAISearchTrigger"
                                          },
                                          {
                                            "concreteType": "HelpLayoutVisualConfig",
                                            "kind": "LinkedField",
                                            "name": "visualConfig",
                                            "plural": false,
                                            "selections": [
                                              (v34/*: any*/),
                                              (v33/*: any*/),
                                              (v32/*: any*/),
                                              (v44/*: any*/),
                                              (v40/*: any*/),
                                              (v35/*: any*/),
                                              (v36/*: any*/)
                                            ]
                                          },
                                          (v5/*: any*/),
                                          (v42/*: any*/)
                                        ],
                                        "type": "HelpLayoutHeroElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutBreadcrumb",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "relativeUrl"
                                              },
                                              (v37/*: any*/)
                                            ]
                                          },
                                          (v42/*: any*/),
                                          (v45/*: any*/)
                                        ],
                                        "type": "HelpLayoutBreadcrumbElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "forgeElementType"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "forgeElementPage"
                                          },
                                          (v42/*: any*/),
                                          (v46/*: any*/),
                                          (v45/*: any*/)
                                        ],
                                        "type": "HelpLayoutForgeElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "connectElementPage"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "connectElementType"
                                          },
                                          (v42/*: any*/),
                                          (v46/*: any*/),
                                          (v45/*: any*/)
                                        ],
                                        "type": "HelpLayoutConnectElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                          },
                                          (v15/*: any*/)
                                        ],
                                        "type": "QueryError"
                                      },
                                      (v28/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutAtomicElementType",
                                            "kind": "LinkedField",
                                            "name": "elementType",
                                            "plural": false,
                                            "selections": [
                                              (v24/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "HelpLayoutNoContentElement"
                                      },
                                      (v17/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v45/*: any*/)
                                        ],
                                        "type": "HelpLayoutKnowledgeCardsElement"
                                      }
                                    ]
                                  },
                                  (v5/*: any*/),
                                  (v45/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "HelpLayoutVisualConfig",
                                        "kind": "LinkedField",
                                        "name": "visualConfig",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutAlignmentSettings",
                                            "kind": "LinkedField",
                                            "name": "alignment",
                                            "plural": false,
                                            "selections": [
                                              (v28/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "HelpLayoutVisualEntity",
                                    "abstractKey": "__isHelpLayoutVisualEntity"
                                  },
                                  (v28/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "HelpLayoutVisualConfig",
                                "kind": "LinkedField",
                                "name": "visualConfig",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/),
                                  (v32/*: any*/),
                                  (v44/*: any*/),
                                  (v35/*: any*/),
                                  (v40/*: any*/),
                                  (v34/*: any*/),
                                  (v36/*: any*/)
                                ]
                              },
                              (v5/*: any*/),
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  (v27/*: any*/),
                                  {
                                    "alias": "dataId",
                                    "kind": "ScalarField",
                                    "name": "__id"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "alias": "layoutId",
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  (v28/*: any*/)
                ],
                "type": "HelpLayout"
              },
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          },
          {
            "args": (v13/*: any*/),
            "concreteType": "HelpLayoutMediaConfig",
            "kind": "LinkedField",
            "name": "mediaConfig",
            "plural": false,
            "selections": (v22/*: any*/)
          },
          {
            "kind": "LinkedField",
            "name": "elementTypes",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHelpLayoutElementType"
              },
              (v23/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "atomicKey",
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "args": (v13/*: any*/),
                    "concreteType": "HelpLayoutMediaConfig",
                    "kind": "LinkedField",
                    "name": "mediaConfig",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v20/*: any*/),
                      (v19/*: any*/),
                      (v18/*: any*/),
                      (v21/*: any*/)
                    ]
                  }
                ],
                "type": "HelpLayoutAtomicElementType"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "compositeKey",
                    "kind": "ScalarField",
                    "name": "key"
                  }
                ],
                "type": "HelpLayoutCompositeElementType"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f09b7daae44197c6ccb5b6c0f121cea2ab89565a6fb603321045725549e0fe99",
    "metadata": {},
    "name": "editCustomPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ced1fe6aab72feb794e7063ba7fe32c0";

export default node;
